import { Stack, Typography, TextField } from '@mui/material';
import { ChangeEvent } from 'react';
import { getIn } from 'formik';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';
import FormErrorMessage from '@shared/components/feedback/FormErrorMessage/FormErrorMessage';
import { FormikSelectField } from '@shared/components/inputs/FormikSelectField';
import { BUSINESS_TYPE_OPTIONS, BUSINESS_SIZE_OPTIONS } from '@constants/leadCaptureConstants';
import { ServiceOfInterestField } from '@components/LeadCaptureForm/sections/ServiceOfInterestField';
import type { LeadCaptureSectionProps } from '@components/LeadCaptureForm/LeadCaptureForm.types';

export const BusinessInformationSection = ({ formik }: LeadCaptureSectionProps) => {
  const { values, touched, errors, handleChange, handleBlur, setFieldValue } = formik;

  if (values.customerType !== 'BUSINESS') return null;

  const tradeNameShowsError =
    Boolean(getIn(touched, 'businessFields.companyTradeName')) && !!getIn(errors, 'businessFields.companyTradeName');
  const companyShowsError = (touched.company && !!errors.company) || tradeNameShowsError;
  const companyHelperText =
    touched.company && errors.company ? <FormErrorMessage>{errors.company as string}</FormErrorMessage> : null;

  const handleCompanyChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleChange(e);
    setFieldValue('businessFields.companyTradeName', e.target.value);
  };

  return (
    <Stack gap="30px">
      <Typography variant="body.emphasis" className="lead-capture-section-heading">
        Business Information
      </Typography>
      <Stack gap="10px">
        <TextFieldLabel label="Legal Business Name" variant="label.fieldMedium" />
        <TextField
          className="lead-capture-text-input"
          name="company"
          placeholder="Enter the registered legal name of the business..."
          value={values.company}
          onChange={handleCompanyChange}
          onBlur={handleBlur}
          error={companyShowsError}
          helperText={companyHelperText}
        />
      </Stack>
      <FormikSelectField
        formik={formik}
        name="businessFields.industrySector"
        label="Business Type"
        placeholder="Select a Business Type"
        options={BUSINESS_TYPE_OPTIONS}
        storeOption
      />
      <ServiceOfInterestField formik={formik} />
      <FormikSelectField
        formik={formik}
        name="businessFields.numberOfEmployees"
        label="Business Size"
        placeholder="Select a Business Size"
        options={BUSINESS_SIZE_OPTIONS}
        storeOption
      />
    </Stack>
  );
};
